// export function StatCard({
//   icon,
//   iconBg,
//   title,
//   value,
//   progress,
//   progressColor,
//   trend,
//   trendUp,
//   subLabel
// }) {
//   return (
//     <div className="bg-white/80 shadow-card rounded-[10px] p-7 hover:shadow-md transition-shadow border border-[#fff] w-full h-full">
//       <div className="flex flex-col justify-between gap-4 w-full h-full">
//         <div className={`${iconBg} rounded-lg p-3 text-white mr-3`}>
//           {icon}
//         </div>
//         <div>
//           <p className="text-sm text-gray-600 mb-1">{title}</p>
//           <h5 className="text-2xl font-semibold">{value}</h5>
//         </div>
//       </div>
//       <div className="w-full bg-gray-200 rounded-full h-1.5 mb-2">
//         <div
//           className={`${progressColor} h-1.5 rounded-full`}
//           style={{ width: `${progress}%` }}
//         ></div>
//       </div>
//       <p className="text-sm flex items-center gap-1">
//         {trend ?
//           <>
//             <span className={trendUp ? 'text-green-600' : 'text-red-600'}>
//               {trendUp ? <TrendingUp className="w-4 h-4 inline" /> : <TrendingDown className="w-4 h-4 inline" />}
//               {trend}
//             </span>
//             {/* <span className="text-gray-600">from last week</span> */}
//           </>
//           :
//           null
//         }
//         <span className="text-gray-600">{subLabel}</span>

import { AlertCircle } from "lucide-react";

//       </p>
//     </div>
//   );
// }
export function StatsCardSkeleton() {
  return (
    <div className="bg-white/80 shadow-card rounded-[10px] p-7 border border-[#fff] w-full h-full">
      <div className="flex flex-col justify-between gap-4 w-full h-full">
        <div className="space-y-3">
          {/* Icon Skeleton */}
          <div className="w-10 h-10 rounded-[5px] bg-gray-200 animate-pulse" />

          <div className="flex flex-col gap-[10px]">
            <div className="flex items-center justify-between">
              {/* Value + Max */}
              <div className="flex items-baseline space-x-2">
                <div className="h-8 w-20 bg-gray-200 rounded animate-pulse" />
                <div className="h-5 w-10 bg-gray-200 rounded animate-pulse" />
              </div>

              {/* Trend Skeleton */}
              <div className="h-6 w-14 bg-gray-200 rounded animate-pulse" />
            </div>

            {/* Title */}
            <div className="h-3 w-32 bg-gray-200 rounded animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
}

// export function StatCard({
//   icon: Icon,
//   iconColor,
//   iconBgColor,
//   maxValue,
//   svg = "",

//   // old

//   iconBg,
//   title,
//   value,
//   trend,
//   trendUp,
// }) {
//   return (
//     <div className="bg-white/80 shadow-card rounded-[10px] p-7 hover:shadow-md transition-shadow border border-[#fff] w-full h-full">
//       <div className="flex flex-col justify-between gap-4 w-full h-full">
//         <div className="space-y-3">
//           <div
//             className={`max-w-max text-2xl p-[5px] rounded-[5px] flex items-center justify-center ${iconBg}`}
//             style={{ color: iconColor, background: iconBgColor }}
//           >
//             {Icon ? <Icon className="h-6 w-6" /> : svg ? svg : null}
//           </div>

//           <div className="flex flex-col gap-[10px]">
//             <div className="flex items-center justify-between">
//               <div className="flex items-baseline space-x-1">
//                 <span className="text-[30px] font-semibold text-[#0E121B]">
//                   {value}
//                 </span>

//                 {maxValue ? (
//                   <span className="text-[18px] text-[#999] font-semibold">
//                     /{maxValue}
//                   </span>
//                 ) : null}
//               </div>

//               {trend ? (
//                 <div
//                   className={`flex items-center gap-0.5 w-fit h-fit px-1.5 py-1 rounded-[4px]  ${trendUp ? "bg-theme-green-light text-theme-green" : "bg-theme-red-light text-theme-red"}`}
//                 >
//                   {trendUp ? (
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="16"
//                       height="16"
//                       viewBox="0 0 16 16"
//                       fill="none"
//                     >
//                       <path
//                         d="M8.46362 13.3333V2.66666M8.46362 2.66666L4.46362 6.66666M8.46362 2.66666L12.4636 6.66666"
//                         stroke="currentColor"
//                         strokeWidth="1.5"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                     </svg>
//                   ) : (
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="16"
//                       height="16"
//                       viewBox="0 0 16 16"
//                       fill="none"
//                     >
//                       <path
//                         d="M8.46368 2.66665L8.46368 13.3333M8.46368 13.3333L12.4637 9.33331M8.46368 13.3333L4.46368 9.33331"
//                         stroke="currentColor"
//                         strokeWidth="1.5"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                     </svg>
//                   )}
//                   <span className={`text-xs font-medium`}>{trend}</span>
//                 </div>
//               ) : null}
//             </div>
//             <p className="text-xs text-[rgba(14,18,27,0.50)] font-medium   leading-tight">
//               {title}
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

export const StatCard = ({
  icon: Icon,
  iconBgColor,
  iconColor,
  svg,
  title,
  value,
  target,
  unit,
  trend,
  trendLabel = "",
  color,
  variant = "",
  alert,
  statsBadge = null,
  statusText = "",
  isAlert,
  subLabel = "",
}) => {
  const LinearProgress = ({ value, max, color = "#10b981", height = 6 }) => {
    const percentage = Math.min((value / max) * 100, 100);
    return (
      <div
        style={{
          width: "100%",
          height,
          backgroundColor: "#f1f5f9",
          borderRadius: height,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${percentage}%`,
            height: "100%",
            backgroundColor: color,
            borderRadius: height,
            transition: "width 1s ease",
          }}
        />
      </div>
    );
  };

  const CircularProgress = ({
    value,
    max,
    size = 48,
    strokeWidth = 4,
    color = "#10b981",
  }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const percentage = Math.min((value / max) * 100, 100);
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    return (
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#f0f0f0"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 1s ease" }}
        />
      </svg>
    );
  };

  const TrendBadge = ({ value, label }) => {
    const isPositive = value >= 0;
    const isNeutral = value === 0;
    const color = isNeutral ? "#94a3b8" : isPositive ? "#10b981" : "#ef4444";
    const bgColor = isNeutral ? "#f8fafc" : isPositive ? "#ecfdf5" : "#fef2f2";
    const arrow = isNeutral ? "" : isPositive ? "↑" : "↓";

    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 2 }}
      >
        <span
          style={{
            fontSize: 11,
            fontWeight: 600,
            color,
            backgroundColor: bgColor,
            padding: "2px 7px",
            borderRadius: 6,
            letterSpacing: 0.2,
          }}
        >
          {arrow} {Math.abs(value)}%
        </span>
        <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 500 }}>
          {label ? label : null}
        </span>
      </div>
    );
  };

  const percentage = Math.min((value / target) * 100, 100);
  const isLow = percentage < 60;

  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: 16,
        padding: "22px 24px",
        display: "flex",
        flexDirection: "column",
        gap: 14,
        border: alert ? "1.5px solid #fecaca" : "1px solid #f1f5f9",
        boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
        transition: "box-shadow 0.2s ease, transform 0.2s ease",
        cursor: "default",
        flex: 1,
        minWidth: 200,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.08)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.04)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {/* <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              backgroundColor: iconBg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 16,
            }}
          >
            {icon}
          </div> */}
          <div
            className={`max-w-max text-2xl p-[5px] rounded-[5px] flex items-center justify-center`}
            style={{ background: iconBgColor, color: iconColor }}
          >
            {Icon ? <Icon className={`w-6 h-6`} /> : svg ? svg : null}
          </div>

          <span
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: "#64748b",
              letterSpacing: 0.3,
              textTransform: "uppercase",
            }}
          >
            {title}
          </span>
        </div>
        {/* {variant === "circular" && (
          <CircularProgress
            value={value}
            max={target}
            color={color}
            size={44}
            strokeWidth={4}
          />
        )} */}
      </div>

      {/* Value */}
      <div className="flex justify-between items-center">
        <div style={{ display: "flex", alignItems: "baseline", gap: 4 }}>
          <span
            style={{
              fontSize: 32,
              fontWeight: 700,
              color: "#0f172a",
              lineHeight: 1,
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            {value}
          </span>

          <span
            style={{
              fontSize: 12.5,
              color: "#94a3b8",
              fontWeight: 500,
              marginTop: 2,
              display: "block",
            }}
          >
            {subLabel ? subLabel : null}
          </span>
       
        </div>

        {trend !== undefined && (
          <TrendBadge value={Number(trend)} label={trendLabel} />
        )}
       
      </div>

      {/* Progress bar (linear variant) */}
      {/* {variant === "linear" && (
        <div>
          <LinearProgress value={value} max={target} color={color} />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 5,
            }}
          >
            <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 500 }}>
              {percentage.toFixed(0)}% complete
            </span>
            <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 500 }}>
              {(target - value).toFixed(value % 1 === 0 ? 0 : 2)} remaining
            </span>
          </div>
        </div>
      )} */}

      {/* Trend */}
      {/* {trend !== undefined && (
        <TrendBadge value={Number(trend)} label={trendLabel} />
      )} */}

      {/* {isAlert ? (
        <div
          className="mt-3 flex items-center gap-1.5 bg-[rgba(0,0,0,0.04)] text-[#8a8480] text-[11px] rounded-lg px-2.5 py-2"
          style={
            statsBadge == "risk"
              ? { background: "rgba(239,68,68,0.12)", color: "#b91c1c" }
              : statsBadge == "best"
                ? { background: "rgba(34,197,94,0.12)", color: "#15803d" }
                : statsBadge == "warning"
                  ? { background: "rgba(249,115,22,0.12)", color: "#c2410c" }
                  : {}
          }
        >
          <AlertCircle className="w-3 h-3 shrink-0" strokeWidth={2.5} />
          {statusText}
        </div>
      ) : null} */}
    </div>
  );
};
export const StatCardOriginal = ({
  icon: Icon,
  iconBgColor,
  iconColor,
  svg,
  title,
  value,
  target,
  unit,
  trend,
  trendLabel = "",
  color,
  variant = "",
  alert,
  statsBadge = null,
  statusText = "",
  isAlert,
  subLabel = "",
}) => {
  const LinearProgress = ({ value, max, color = "#10b981", height = 6 }) => {
    const percentage = Math.min((value / max) * 100, 100);
    return (
      <div
        style={{
          width: "100%",
          height,
          backgroundColor: "#f1f5f9",
          borderRadius: height,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${percentage}%`,
            height: "100%",
            backgroundColor: color,
            borderRadius: height,
            transition: "width 1s ease",
          }}
        />
      </div>
    );
  };

  const CircularProgress = ({
    value,
    max,
    size = 48,
    strokeWidth = 4,
    color = "#10b981",
  }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const percentage = Math.min((value / max) * 100, 100);
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    return (
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#f0f0f0"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 1s ease" }}
        />
      </svg>
    );
  };

  const TrendBadge = ({ value, label }) => {
    const isPositive = value >= 0;
    const isNeutral = value === 0;
    const color = isNeutral ? "#94a3b8" : isPositive ? "#10b981" : "#ef4444";
    const bgColor = isNeutral ? "#f8fafc" : isPositive ? "#ecfdf5" : "#fef2f2";
    const arrow = isNeutral ? "" : isPositive ? "↑" : "↓";

    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 2 }}
      >
        <span
          style={{
            fontSize: 11,
            fontWeight: 600,
            color,
            backgroundColor: bgColor,
            padding: "2px 7px",
            borderRadius: 6,
            letterSpacing: 0.2,
          }}
        >
          {arrow} {Math.abs(value)}%
        </span>
        <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 500 }}>
          {label ? label : null}
        </span>
      </div>
    );
  };

  const percentage = Math.min((value / target) * 100, 100);
  const isLow = percentage < 60;

  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: 16,
        padding: "22px 24px",
        display: "flex",
        flexDirection: "column",
        gap: 14,
        border: alert ? "1.5px solid #fecaca" : "1px solid #f1f5f9",
        boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
        transition: "box-shadow 0.2s ease, transform 0.2s ease",
        cursor: "default",
        flex: 1,
        minWidth: 200,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.08)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.04)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {/* <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              backgroundColor: iconBg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 16,
            }}
          >
            {icon}
          </div> */}
          <div
            className={`max-w-max text-2xl p-[5px] rounded-[5px] flex items-center justify-center`}
            style={{ background: iconBgColor, color: iconColor }}
          >
            {Icon ? <Icon className={`w-6 h-6`} /> : svg ? svg : null}
          </div>
          <span
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: "#64748b",
              letterSpacing: 0.3,
              textTransform: "uppercase",
            }}
          >
            {title}
          </span>
        </div>
        {variant === "circular" && (
          <CircularProgress
            value={value}
            max={target}
            color={color}
            size={44}
            strokeWidth={4}
          />
        )}
      </div>

      {/* Value */}
      <div>
        <div style={{ display: "flex", alignItems: "baseline", gap: 4 }}>
          <span
            style={{
              fontSize: 32,
              fontWeight: 700,
              color: "#0f172a",
              lineHeight: 1,
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            {value}
          </span>
          <span style={{ fontSize: 14, color: "#94a3b8", fontWeight: 500 }}>
            {unit}
          </span>
        </div>
        <span
          style={{
            fontSize: 12.5,
            color: "#94a3b8",
            fontWeight: 500,
            marginTop: 2,
            display: "block",
          }}
        >
          {subLabel
            ? subLabel
            : statsBadge
              ? statsBadge
              : target || unit
                ? `of ${target} ${unit} target`
                : null}
        </span>
      </div>

      {/* Progress bar (linear variant) */}
      {variant === "linear" && (
        <div>
          <LinearProgress value={value} max={target} color={color} />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 5,
            }}
          >
            <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 500 }}>
              {percentage.toFixed(0)}% complete
            </span>
            <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 500 }}>
              {(target - value).toFixed(value % 1 === 0 ? 0 : 2)} remaining
            </span>
          </div>
        </div>
      )}

      {/* Trend */}
      {trend !== undefined && (
        <TrendBadge value={Number(trend)} label={trendLabel} />
      )}

      {isAlert ? (
        <div
          // className="mt-3 flex items-center gap-1.5 text-[11px] rounded-lg px-2.5 py-2"
          className="mt-3 flex items-center gap-1.5 bg-[rgba(0,0,0,0.04)] text-[#8a8480] text-[11px] rounded-lg px-2.5 py-2"
          style={
            statsBadge == "risk"
              ? { background: "rgba(239,68,68,0.12)", color: "#b91c1c" }
              : statsBadge == "best"
                ? { background: "rgba(34,197,94,0.12)", color: "#15803d" }
                : statsBadge == "warning"
                  ? { background: "rgba(249,115,22,0.12)", color: "#c2410c" }
                  : {}
          }
        >
          <AlertCircle className="w-3 h-3 shrink-0" strokeWidth={2.5} />
          {statusText}
        </div>
      ) : null}
    </div>
  );
};
